import { render } from "./categoryConference.vue?vue&type=template&id=a8b8d11c"
import script from "./categoryConference.vue?vue&type=script&lang=js"
export * from "./categoryConference.vue?vue&type=script&lang=js"

import "./categoryConference.vue?vue&type=style&index=0&id=a8b8d11c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__